import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Observable } from 'windowed-observable';
import CustomErrorBoundary, { ErrorCode } from '../../ErrorHandling/CustomErrorBoundary';
import ErrorComponent from '../../ErrorHandling/ErrorComponent';
import { GreetingSection } from '../../components/GreetingSection/GreetingSection';
import { useGlobalStateContext } from '../../context/GlobalStateContext/GlobalStateContext';
import { lazyLoadGoalsApp, lazyLoadSalesApp } from '../../microfrontends/';
const observable = new Observable('globalState');
let SalesAppLazyLoad = lazyLoadSalesApp();
let GoalsComponentLazyLoad = lazyLoadGoalsApp();
export const Sales = ({ initialState }) => {
    const { globalState } = useGlobalStateContext();
    const location = useLocation();
    const salesAppErrorStatus = SalesAppLazyLoad._payload._status == 2;
    const goalsAppErrorStatus = GoalsComponentLazyLoad._payload._status == 2;
    useEffect(() => {
        console.log(' SalesAppLazyLoad ', SalesAppLazyLoad);
        // Attempt importing the app again (if previous status shows error)
        if (salesAppErrorStatus)
            SalesAppLazyLoad = lazyLoadSalesApp();
        if (goalsAppErrorStatus)
            GoalsComponentLazyLoad = lazyLoadGoalsApp();
        console.log('salesAppErrorStatus ', salesAppErrorStatus);
    }, []);
    useEffect(() => {
        observable.publish(globalState);
    }, [globalState.merchant.number]);
    return (_jsx(Box, { children: _jsxs(CustomErrorBoundary, { isPageLevel: true, error: salesAppErrorStatus ? ErrorCode.APPDOWN : 0, children: [location.pathname === '/sales' && !salesAppErrorStatus && _jsx(GreetingSection, {}), _jsx(SalesAppLazyLoad, { initialState: initialState }), goalsAppErrorStatus ? ( // Contain goalsApp error
                _jsx(ErrorComponent, { errorCode: ErrorCode.APPDOWN })) : (_jsx(GoalsComponentLazyLoad, { initialState: initialState }))] }, location.pathname) }));
};
